import getLinksRequest from "./requests/get-links-request";
import diagnosticsRequest from "./requests/diagnostics-request";

const integrateRepository = {
    getLinks: getLinksRequest,
    diagnostics: diagnosticsRequest,
};

export default integrateRepository;
